<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
      @if (tooltipKey()) {
        <app-directus-tooltip class="ml-2" [tooltipKey]="tooltipKey()" />
      }
      <ng-content select="[labelBadge]" />
    </label>
  }

  @if (isReadOnly()) {
    <input
      pInputText
      [value]="value() | date: readOnlyFormat() : '' : userLanguage()"
      [disabled]="true"
      class="w-full"
    />
  } @else {
    <p-datePicker
      [id]="id()"
      [(ngModel)]="value"
      [minDate]="minDate() ?? undefined"
      [maxDate]="maxDate() ?? undefined"
      [dateFormat]="dateFormat()"
      [placeholder]="placeholder() || label() | transloco"
      [showIcon]="true"
      [fluid]="true"
      [invalid]="showInvalid()"
      appendTo="body"
      (onBlur)="markAsTouched()"
    ></p-datePicker>
  }
</div>
